import { render, staticRenderFns } from "./EmptyRouterLayout.vue?vue&type=template&id=1bfe0dbd&"
import script from "./EmptyRouterLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyRouterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports